/**
 * Catalog titles still arrive as "Roulette Standard" / "Blackjack".
 * The live products operators see are the Royal tables.
 */
export function displayTitle(title: string | null | undefined): string {
  const raw = (title ?? '').trim();
  if (!raw) return '';

  const n = raw.toLowerCase().replace(/\s+/g, ' ');

  if (/^(royal )?roulette( standard)?$/.test(n) || n === 'standard roulette') {
    return 'Royal Roulette';
  }
  if (/^(royal )?blackjack( standard)?$/.test(n) || n === 'standard blackjack') {
    return 'Royal Blackjack';
  }

  return raw;
}
